// extracted by mini-css-extract-plugin
module.exports = {"block":"Harvest_block__3F888","chartContainer":"Harvest_chartContainer__1diH7"};